import { render } from "./BusinessAreasAndTankTerminals.vue?vue&type=template&id=0f0210b8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__